if (window.location.pathname === '/') {
function Marquee(selector, speed) {
  const parentSelector = document.querySelector(selector);  // Der Container der Bilder
  const items = parentSelector.children;  // Alle Brand-Items im Container
  const totalWidth = Array.from(items).reduce((width, item) => width + item.offsetWidth, 0);  // Berechne die gesamte Breite des Contents
  let offset = 0;  // Initialer Offset für die Bewegung
  const clone = parentSelector.innerHTML;  // Erstelle ein Duplikat des Containers

  // Klone den Inhalt zweimal für den Endlos-Effekt
  parentSelector.insertAdjacentHTML('beforeend', clone);
  parentSelector.insertAdjacentHTML('beforeend', clone);

  // Setze ein Intervall, das die Bewegung der Elemente steuert
  setInterval(function() {
    // Bewege den gesamten Container nach links
    parentSelector.style.transform = `translateX(-${offset}px)`;
    
    // Wenn der gesamte Inhalt aus dem Bildschirm verschwunden ist, setze den Offset zurück
    if (offset >= totalWidth) {
      offset = 0;
    }
    
    // Erhöhe den Offset je nach Geschwindigkeit
    offset += speed;
  }, 10);  // Das Intervall sorgt für flüssige Bewegung
}
document.querySelector('.scrollbar').style.overflow = 'visible';
document.querySelector('.section-wrapper .scrollbar').parentElement.style.cssText = 'transform: rotate(-5deg); padding: 3rem 0 5rem;';



// Starte den Marquee-Effekt nach dem Laden der Seite
window.addEventListener('load', function() {
  Marquee('.brand-image.scrollbar', 0.4);  // Wende den Effekt auf den Container an, Geschwindigkeit 0.2
});
}

